import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import {
  ClientesControlCliModule, FiltroGruposControlCliModule,
  GrupoControlCliModule, FiltroUsuarioControlCliModule, UsuariosControlCliModule
} from '../model/user-control-cli';
import { map } from 'rxjs/operators';
import { InventarioSSO } from '../model/inventario-sso';

@Injectable({
  providedIn: 'root'
})
export class UserControlCliService {

  constructor(
    private http: HttpClient
  ) { }

  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  urlBaseUsuarios = environment.API_BASE + '/Users';

  getClients(): Observable<ClientesControlCliModule[]> {
    return this.http.get<ClientesControlCliModule[]>(this.urlBaseUsuarios + '/GetClientsAdministrative');
  }

  getGroups(filtro: FiltroGruposControlCliModule, from: number = 0, to: number = 10): Observable<GrupoControlCliModule[]> {
    return this.http.post<GrupoControlCliModule[]>(this.urlBaseUsuarios + '/GetGroupsAdministrative?from=' + from + '&size=' + to,
      JSON.stringify(filtro),
      { headers: this.headers });
  }

  getUsuarios(filtro: FiltroUsuarioControlCliModule, from: number, to: number = 10): Observable<UsuariosControlCliModule> {
    const llamada = this.urlBaseUsuarios + '/GetUserForAdministrativeClient?from=' + from + '&size=' + to;
    return this.http.post<UsuariosControlCliModule>(llamada, JSON.stringify(filtro), { headers: this.headers });
  }

  DeleteUserAccessComplWithGrupo(idGroup: number): Observable<boolean> {
    const llamada = this.urlBaseUsuarios + '/DeleteUserAccessComplWithGrupo?idAccess=' + idGroup;
    return this.http.get<boolean>(llamada);
  }

  deleteGroupCompl(idGroupCompl: number): Observable<boolean>{
    const llamada = this.urlBaseUsuarios + '/DeleteUserAccessCompl?idAccess=' + idGroupCompl;
    return this.http.get<boolean>(llamada);
  }

  getGroupCompl(idUser: number): Observable<any> {
    const llamada = this.urlBaseUsuarios + '/GetUserAccessCompl?idUser=' + idUser;
    return this.http.get<any>(llamada);
  }

  resetGroupCompl(idUser: number): Observable<any> {
    const llamada = this.urlBaseUsuarios + '/ResetUserAccessCompl?idUser=' + idUser;
    return this.http.get<any>(llamada);
  }

  addGroupCompl(idUser: number, idGrupo: number): Observable<any> {
    const llamada = this.urlBaseUsuarios + '/AddAccessGrupoCompl?idUser=' + idUser + '&idGrupo=' + idGrupo;
    return this.http.get<any>(llamada);
  }

  getInventario(from: number, size: number, refExterna?: string, idSetMulti?: number): Observable<any> {
    const llamada = this.urlBaseUsuarios + '/GetInventarioSSO?referenciaExterna=' + refExterna + '&idSetMulti='
      + idSetMulti + '&from=' + from + '&size=' + size;
    return this.http.get<any>(llamada);
  }

}
